import { z } from 'zod';
import { BaseStatFilterSchema } from '../../../schemas';
import { useTop149ChartQuery } from './useTop149Query';

interface UseTop149ChartParams {
	filters?: z.infer<typeof BaseStatFilterSchema>;
	yearsAchieveTop149?: number;
}

export function useTop149Chart(params?: UseTop149ChartParams) {
	const { data: nivoData, isLoading, error } = useTop149ChartQuery({
		filters: params?.filters,
		yearsAchieveTop149: params?.yearsAchieveTop149,
	});

	return {
		nivoData: nivoData?.data || null,
		isLoading,
		error
	};
}
